<template>
  <div class="atlas-wrapper">
    <div class="atlas-inner"
         v-if="detailData">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div v-for="(item, index) in imgList"
               :key="index"
               class="swiper-slide">
            <img class="loading"
                 src="../assets/img/loading.gif"
                 alt="">
            <img class="image"
                 :src="item.image || ''"
                 @load="imgLoad"
                 @error="imgError"
                 alt="">
            <div class="content">
              <span class="num">{{currentIndex + 1}} / {{imgList.length}}</span>
              <div class="detail">
                <h4 v-html="detailData.title"></h4>
                <div class="info">
                  <span v-if="detailData.publishTime">{{detailData.publishTime | time}}</span>
                  <i v-if="detailData.source">{{$tc('channel.source')}}{{detailData.source}}</i>
                </div>
                <p v-html="filterContent(item.desc)"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Moment from 'moment'
import Swiper from 'swiper/js/swiper.min.js'
import 'swiper/css/swiper.css'

import Filters from '@/utils/filters'

// import { mapMutations } from 'vuex'
import { mapMutations } from 'vuex'

export default {
  name: 'News',
  data () {
    return {
      id: '',
      detailData: null,
      expireSign: '',
      imgList: [],
      emptydata: null,
      currentIndex: 0
    }
  },
  created () {
    this.id = this.$route.params.id
    this.expireSign = this.$route.query.expireSign
    this.getDate()
  },
  beforeRouteLeave (to, form, next) {
    this.$Common.track('unload', {
      name: this.detailData && this.detailData.title,
      id: this.id,
      type: '资讯'
    }).then(() => {
      next()
    })
  },
  mounted () {
    document.querySelector('.atlas-page').style.height = window.innerHeight + 'px'
  },
  computed: {
  },
  methods: {
    ...mapMutations(['setShowLoading']),
    getDate () {
      this.$Api.getNewsDetail({
        newsId: this.id,
        expireSign: this.expireSign
      }).then(data => {
        if (data) {
          data.item && (this.detailData = data.item)
          data.share && this.share(data.share)
          this.imgList = (data.item && data.item.imageSet) || []
          this.$nextTick(() => {
            this.swiper()
          })
          data.item && this.$Common.track('load', {
            title: data.item.title,
            id: this.id,
            type: '资讯'
          })
        } else {
          this.emptydata = {
            type: 'nodata',
            theme: 'blue'
          }
        }
        !this.imgList.length && (this.emptydata = {
          type: 'nodata',
          theme: 'blue'
        })
        this.setShowLoading(false)
      }).catch((err) => {
        if (err === 404) {
          this.emptydata = {
            type: 'nodata',
            theme: 'blue'
          }
        } else {
          this.emptydata = {
            type: 'nonetwork',
            theme: 'blue'
          }
        }
        this.setShowLoading(false)
      })
    },
    swiper () {
      const _this = this
      new Swiper('.atlas-inner .swiper-container', {
        on: {
          slideChangeTransitionStart () {
            _this.currentIndex = this.realIndex
          }
        }
      })
    },
    share (obj) {
      this.$nextTick(() => {
        this.$Common.onshare(obj)
      })
    },
    imgLoad (e) {
      e.target.previousElementSibling.style.display = 'none'
    },
    imgError (e) {
      e.target.previousElementSibling.style.display = 'none'
    },
    filterContent (data) {
      return Filters.filterContent(data)
    }
  },
  filters: {
    time (times) {
      return Moment(times).format('YYYY-MM-DD HH:mm')
    }
  }
}
</script>

<style lang="scss">
.atlas-wrapper {
  height: 100%;
  .atlas-inner {
    height: 150vw;
    background-color: #000;
  }
  .swiper-container {
    height: 100%;
    .swiper-wrapper {
      height: 100%;
      .swiper-slide {
        padding: 0 3.5vw;
        box-sizing: border-box;
        .loading {
          position: absolute;
          left: 50%;
          top: 50%;
          width: 13vw;
          transform: translate(-50%, -50%);
        }
        .image {
          width: auto;
          max-width: 100%;
          max-height: 100%;
          position: relative;
          left: 50%;
          top: 50%;
          display: block;
          transform: translate(-50%, -50%);
        }
        .content {
          position: absolute;
          bottom: 5vw;
          left: 0;
          text-align: left;
          width: 100%;
          padding: 0 3.5vw;
          box-sizing: border-box;
          .num {
            color: #fff;
            font-size: 4.2vw;
            line-height: 1.4;
            margin-bottom: 4vw;
            display: block;
            text-shadow: 0 0 3px #000;
          }
          .detail {
            h4 {
              color: #f1f0f0;
              font-size: 4.5vw;
              line-height: 1.4;
              margin: 0 0 1vw;
              word-wrap: break-word;
              text-shadow: 0 0 3px #000;
            }
            .info {
              color: rgba(241, 240, 240, 0.4);
              font-size: 3.241vw;
              line-height: 1.4;
              margin-bottom: 2.407vw;
              display: flex;
              text-shadow: 0 0 1px #000;
              span {
                flex-shrink: 0;
              }
              i {
                overflow: hidden;
                font-style: normal;
                flex: 1;
                text-overflow: ellipsis;
                white-space: nowrap;
                margin-left: 1.852vw;
              }
            }
            p {
              word-wrap: break-word;
              color: rgba(241, 240, 240, 0.4);
              font-size: 3.7vw;
              line-height: 1.4;
              text-shadow: 0 0 1px #000;
            }
          }
        }
      }
    }
  }
}
</style>
